<template>

  <div id="more" class="container">

    <!--<app-navigation></app-navigation>-->

    <h1>more</h1>

    <p>coming soon ...</p>

  </div>
</template>
<script>
  // import Navigation from './Navigation.vue'

  export default {
    data () {
      return {}
    },
    components: {
      // appNavigation: Navigation
    }
  }
</script>
<style lang="scss" scoped>

  div#more {
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// More.vue?186ca978